module.exports = __webpack_public_path__ + "static/AppIconSettings-2bf3927fa6059f2c8111cefa4f9efac1.png";